import * as React from "react";
import { GETJsonRaceLiveSetting, POSTJsonRaceLiveSetting } from "../api";
import { context } from "components/context/Context";
import SettingForm from "components/pages/Settings/SettingForm";
import { Modal } from "antdv5";

const options: [string, string][] = [["顯示掃描明細", "SHOWSCANDETAILPAGE"]];

const TopMenuSettings = () => {
  const [isOpen, setOpen] = React.useState(false);
  const [settings, setSettings] = React.useState({});
  const { state } = React.useContext(context);
  const ref = React.useRef<Record<string, number> | null>(null);
  const onSubmit = async (settings: Record<string, number>) => {
    setOpen(true);
    ref.current = settings;
  };
  const onModalCancel = () => {
    setOpen(false);
  };
  const onModalOk = async () => {
    if (ref.current) {
      await POSTJsonRaceLiveSetting(
        state.gid,
        "globaltopmenu",
        state.token,
        ref.current
      );
      setOpen(false);
    }
  };
  React.useEffect(() => {
    if (state.gid) {
      GETJsonRaceLiveSetting(state.gid, "globaltopmenu").then((res) => {
        const processed = Object.fromEntries(
          res.map((obj: Record<string, any>) => [
            obj.settingName,
            Number.parseInt(obj.settingValue),
          ])
        );
        setSettings(processed);
      });
    }
  }, [state.gid]);
  return (
    <div>
      <SettingForm
        onSubmit={onSubmit}
        options={options}
        defaultValue={settings}
      />
      <Modal open={isOpen} onOk={onModalOk} onCancel={onModalCancel}>
        <h1>注意!</h1>
        <p>確定送出?</p>
      </Modal>
    </div>
  );
};
export default TopMenuSettings;
